

<div fxLayout="column" class="page-layout simple fullwidth" fxFlex>
  <div class="content inner-scroll" fusePerfectScrollbar>
    @if (graphsAreAvailable()) {
      <app-banner-info [rolesCanShowBanner]="rolesCanShowBannerInfo" situation="progression"></app-banner-info>
      <app-graph-selector></app-graph-selector>
      <app-shared-filters></app-shared-filters>
      <router-outlet></router-outlet>
    } @else {
      <p class="graphs-are-not-available">{{'graph_inclusive.graphs_are_not_available' | translate}}</p>
    }
  </div>
</div>